import nlnAxios from "../../../api/nlnAxios";


//Create FAQs

const createFaqs = async (faqData, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.post("/library/faqs/", faqData);

    return response.data;
}

//Edit Resources
const editFaq = async (faqData, token) => {

    //     const config = {
    //         headers: {
    //             Authorization: `Bearer ${token}`
    //     }
    // }   

    const response = await nlnAxios.patch(`/library/faqs/${faqData.faqId}`, faqData);
    return response.data

}

//Get FAQs

const getFaqs = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    const response = await nlnAxios.get("/library/faqs/");

    return response.data;
}

//Delete resource category 
const deleteFaqs = async (faqId, token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }

    }

    const response = await nlnAxios.delete("/library/faqs/" + faqId);

    return response.data;
}

// getSystemFaqs

const getSystemFaqs = async (token) => {

    const config = {
        headers: {
            Authorization: `Bearer ${token}`
    }
}

    // const response = await nlnAxios.get("/library/public/faqs/?faqCategoryType=system");

    const response = await nlnAxios.get("/library/public/faqs/");

    return response.data;
}


const faqService = {
    createFaqs,
    getFaqs,
    deleteFaqs,
    editFaq,
    getSystemFaqs
}

export default faqService;